<template>
  <div>
    <b-btn-group class="btn-block" size="sm">
      <b-button variant="primary" @click="$emit('add')" v-if="showAdd"><b-icon icon="plus"/></b-button>
      <b-button variant="info" @click="$emit('delete')" v-if="showDelete"><b-icon icon="dash"/></b-button>
      <b-dropdown
        variant="outline-secondary"
        class="btn-block text-left"
        :text="buttonText"
        size="sm"
        ref="roomDropdown"
        lazy no-caret
        >
        <b-dropdown-form>
          <b-form-group>
            <b-input-group size="sm" :prepend="$gettext('adults')">
              <b-form-input min="1" type="number" :id="'adults' + id" :name="'adults' + id" v-model="room.adults"></b-form-input>
            </b-input-group>
            <b-input-group size="sm" :prepend="$gettext('children')" class="my-2">
              <b-form-input min="0" type="number" :id="'children' + id" :name="'children' + id" v-model="children" ></b-form-input>
            </b-input-group>
            <template v-if="room.ages.length">
              <div role="separator" class="dropdown-divider"></div>
              <div class="text-center"><strong v-translate>children age</strong></div>
            </template>
            <template v-for="(age, i) in room.ages">
              <b-input-group size="sm" :prepend="`${$gettext('child')} ${i + 1}:`" class="my-2" :key="'age' + i">
                <b-form-input min="1" type="number" :id="'age'+ id + i" :name="'age' + id + i" v-model="room.ages[i]" ></b-form-input>
              </b-input-group>
            </template>
          </b-form-group>
        </b-dropdown-form>
      </b-dropdown>
    </b-btn-group>
  </div>
</template>

<script>
export default {
  name: 'SearchFormRoom',
  props: ['value', 'showAdd', 'showDelete', 'id'],
  data () {
    return {
      room: this.value
    }
  },
  computed: {
    children: {
      get: function () {
        return this.room.ages.length
      },
      set: function (newVal) {
        const len = this.room.ages.length
        if (len > newVal) this.room.ages.splice(newVal)
        else for (var i = len; i < newVal; i++) this.room.ages.push(12)
      }
    },
    buttonText: function () {
      let text = '' + this.room.adults + ' '
      text += this.room.adults > 1 ? this.$gettext('adults') : this.$gettext('adult')
      text += ', ' + this.room.ages.length
      if (this.room.ages.length === 1) text += ' ' + this.$gettext('child')
      else text += ' ' + this.$gettext('children')
      return text
    }
  }
}
</script>

<style lang="scss">
fieldset{
  margin-top: 2px;
    legend {
    padding-bottom:0px!important;
  }
}
</style>
